export default __webpack_public_path__ + "static/5-e00a87f552aab16f1402d4498c542171.jpg";